var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goToTop show--smallScreens",on:{"click":function($event){}}},[_c('i',{staticClass:"icon-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }